/** @jsx jsx */
import TextFeature from 'components/text-feature';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import WorkDistribution from 'sections/work-distribution';
import { Box, Container, jsx } from 'theme-ui';

const data = {
  subTitle: 'Our Client',
  title: 'Several client were working with',
  description:
    'View a situation from a client\'s point of view and understand what they value, you can provide a fair solution that will edify the consumer and strengthen your relationship with them.',
};

export default function ClientSection() {
  // Graphql image query
  const dataThumb = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "partner.png" }) {
        childImageSharp {
          fluid(maxWidth: 665) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <section sx={{ variant: 'section.partner' }} id="client">
      <Container sx={styles.containerBox}>
        <Box sx={styles.contentBox}>
          <TextFeature
            subTitle={data.subTitle}
            title={data.title}
            description={data.description}
            btnName={data.btnName}
            btnURL={data.btnURL}
          />
        </Box>
        <Box sx={styles.thumbnail}>
          <Img fluid={dataThumb.placeholderImage.childImageSharp.fluid} />
        </Box>
      </Container>
      <WorkDistribution/>
    </section>
  );
}
const styles = {
  containerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: ['wrap', null, null, 'nowrap'],
  },
  thumbnail: {
    px: [0, null, '40px', 0],
    width: ['100%', null, null, 360, 550, 655, null, 765],
  },
  contentBox: {
    flexShrink: 0,
    px: [0, null, '30px'],
    pt: [0, null, '50px'],
    textAlign: ['center', null, null, 'left'],
    width: ['100%', 450, 550, '350px', '410px', '485px'],
    mx: 'auto',
    pb: ['30px', null, null, 0],
    '.description': {
      pr: [0, null, null, null, 4],
    },
  },
};
